import { Checkbox } from "@mui/material";
import Modal from "@mui/material/Modal";
import Pagination from "@mui/material/Pagination";
// import axios from "axios";
// import { saveAs } from "file-saver";
import React, { useEffect, useState } from "react";
import { FiChevronDown, FiEye } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { FormatStatus } from "../../../../../utils/functions/FormatStatus";
import { formatDate } from "../../../../../utils/hooks/convertDate";
import { convertToDecimal } from "../../../../../utils/hooks/useConvertToDecimal";
import {
  useApprovePaymentRequestMutation,
  useGetVendorPaymentsQuery,
  // useGeneratePaymentScheduleMutation,
} from "../../../../api";
import PageStyle from "../../../Components/Layout/FinancePageLayout";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { CalendarFilter2, ProDropFilter, SearchFilter } from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table";
import DashboardStyle from "../../../Styles//Dashboard.module.css";

let currentHeaders = [
  {
    title: "Vendor Name",
    key: "Vendor Name",
  },
  {
    title: "Initiator Name",
    key: "InitiatorName",
  },
  {
    title: "Initiator Id",
    key: "InitiatorId",
  },
  {
    title: "Payment Date",
    key: "PaymentDate",
  },
  {
    title: "Amount",
    key: "amount",
  },
  {
    title: "Narration",
    key: "narration",
  },
  {
    title: "Payment Status",
    key: "PaymentStatus",
  },
];

const ViewVendorPayment = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = React.useState(1);
  const succeessValue = useSelector((state) => state?.global?.value);
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('')
  const handleChange = (event, value) => {
    setPage(value);
  };
  useEffect(() => {
    if (succeessValue === "success") {
      setOpen(false);
    }
  }, [succeessValue]);

  const navigate = useNavigate();

  const [approvalStatus, setApprovalStatus] = useState('');
  const itemsPerPage = 10;
  const { data: paymentReqData } = useGetVendorPaymentsQuery(
    {
      PageSize: itemsPerPage,
      PageNumber: page,
      PaymentStatus: approvalStatus,
      StartDate: startDate ? new Date(startDate)?.toISOString() : '',
      EndDate: endDate ? new Date(endDate)?.toISOString() : ''
    }
  );


  const filterBy = [
    {
      name: "Paid",
      filter: 0,
    },
    {
      name: "Not Paid",
      filter: 1,
    },
  ];


  const handleSearch = (e) => {
    setSearch(e.target.value);
  };


  return (
    <RouteLayout title={"Veiw Vendor Payment"}>
      <PageStyle
        title={"Veiw Vendor Payment"}
        hasBack={false}
        isMain={true}
      >
        <div className="w-full flex items-end justify-between mb-3">
          <div className="flex items-center justify-end gap-5">
            {/* <SearchFilter
              text={(value) => setSearch(value)}
              fromHeader={true}
              onChange={handleSearch}
            /> */}
            <CalendarFilter2
              name="Select Date Range"
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
            <ProDropFilter
              filter={approvalStatus} name={'Status'}
              setFilter={setApprovalStatus}
              filterBy={filterBy}
            />
          </div>
        </div>
        <div className={DashboardStyle.dashboard_table_holder}>
          <Table>
            <thead>
              <tr>

                {currentHeaders.map((header, _index) => (
                  <th
                    className={`!text-[#29382A] ${header.title === "Actions" && "flex justify-end !pr-6"
                      }`}
                    key={_index + 1}
                  >
                    {header.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paymentReqData?.result?.map((item, index) => {
                return (
                  <tr key={index}>
                    {/* <td>
                      <Checkbox
                         checked={selectedItems.some(
                          (selectedItem) => selectedItem.id === item.id
                        )}
                        onChange={(e) =>
                          handleCheckboxChange(item, e.target.checked)
                        }
                      />
                    </td> */}
                    <td className="text-[#29382A] ">{item?.vendorName}</td>
                    <td>{item?.intiatorName}</td>
                    <td>{item?.intiatorId}</td>
                    <td>{formatDate(item?.paymentDate)}</td>
                    <td>₦ {convertToDecimal(item?.amount) ?? "--"} </td>
                    <td>{item?.narration}</td>
                    <td>{item?.paymentStatusDescription}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>

        <div className="flex justify-between">
          <p>Showing page: {page}</p>
          <Pagination

            count={paymentReqData?.totalPages}

            page={page}
            onChange={handleChange}
          />
        </div>

      </PageStyle>
    </RouteLayout>
  );
};

export default ViewVendorPayment;
